import { Box, Button, Divider, Pagination, Typography } from '@mui/material'
import SearchInput from 'components/search/SearchInput'
import { dateFormatter } from 'core/helpers/date-formatter'
import { usePageParam } from 'core/hooks/usePageParam'
import { useSearchParamState } from 'core/hooks/useSearchParamState'
import { ArrowBack } from 'core/icons'
import { parseLockers } from 'pages/Lockers/parse'
import { HistorySosStatusColor, HistorySosStatusText } from 'pages/Sos/enum'
import React from 'react'
import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { getSosHistory } from 'services/sos/sos.service'

export const HistorySosPage = () => {
	const [page, setPage] = usePageParam(1)
	const [search, setSearch, debouncedSearch] = useSearchParamState()
	const navigate = useNavigate()
	const { data: history } = useQuery(['getSosHistory', page, debouncedSearch], {
		queryFn: () =>
			getSosHistory({
				page,
				search: debouncedSearch.length > 0 ? debouncedSearch : null
			})
	})
	const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
		setPage(value)
	}
	const onChangeSearch = (e: any) => {
		setSearch(e.target.value)
	}
	return (
		<div>
			<Box p={2} display='flex' alignItems='center'>
				<Button
					color='info'
					variant='text'
					size='small'
					onClick={() => navigate(-1)}
					sx={{ border: 0, borderRadius: '50%', marginRight: '16px' }}
				>
					<ArrowBack style={{ fill: '#349EFF', marginRight: '12px' }} /> Назад
				</Button>
				<Typography variant='title_2'>История</Typography>
			</Box>
			<Divider />
			<Divider />
			<Box p={2} display='flex' justifyContent='end'>
				<SearchInput search={search} onChangeSearch={onChangeSearch} />
			</Box>
			<Divider />
			<Box display='flex' flexDirection='column' justifyContent='center' alignItems='center'>
				{history?.data &&
					Object.keys(history?.data).map(key => (
						<Box mt={6} width={500} key={`sos-history-${key}`}>
							<Typography variant='headline_1' color='primary.black' mb={4}>
								{key}
							</Typography>
							{history?.data[key] &&
								parseLockers(history?.data[key]).map((data: any) => (
									<Box display='flex' flexDirection='column' mb={2}>
										<Box display='flex' justifyContent='space-between' mb={2}>
											<Box display='flex' flexDirection='column'>
												<Box display='flex' mb={1}>
													<Typography
														variant='caption_1'
														sx={{
															color: HistorySosStatusColor[
																data.status as keyof typeof HistorySosStatusColor
															]
														}}
														mr={1}
													>
														{
															HistorySosStatusText[
																data.status as keyof typeof HistorySosStatusText
															]
														}
													</Typography>
													<Typography variant='caption_1_regular' color='primary.gray'>
														- {dateFormatter(new Date(data.created_at))}
													</Typography>
												</Box>
												<Typography variant='body_2' color='primary.black' mb={1}>
													{data.issue_point.address}
												</Typography>
												<Box>
													<Typography variant='footnote_1' color='primary.gray'>
														{data.comment}
													</Typography>
												</Box>
											</Box>
											<Box
												display='flex'
												flexDirection='column'
												justifyContent='center'
												alignContent='center'
											>
												<Typography variant='body_1'>{data.price}</Typography>
											</Box>
										</Box>
										<Divider />
									</Box>
								))}
						</Box>
					))}
				{history?.last_page && (
					<Box display='flex' justifyContent='center'>
						<Pagination
							sx={{ marginTop: '16px' }}
							count={history.last_page}
							page={page}
							onChange={handleChange}
						/>
					</Box>
				)}
			</Box>
		</div>
	)
}
